import { BenefitData } from './types';

interface BenefitCardProps {
  benefit: BenefitData;
  index: number;
  isVisible: boolean;
}

export const BenefitCard: React.FC<BenefitCardProps> = ({ benefit, isVisible }) => {
  return (
    <div
      className={`bg-card border rounded-xl px-6 py-6 backdrop-blur-sm transition-opacity duration-300 h-64 flex flex-col items-start justify-center ${
        isVisible ? 'opacity-100' : 'opacity-0'
      }`}
    >
      <div className="mb-4 flex items-baseline gap-1">
        <span className="text-6xl sm:text-7xl font-bold text-primary">{benefit.stat}</span>
        <span className="text-base text-primary">{benefit.unit}</span>
      </div>
      <h3 className="text-xl font-semibold text-foreground mb-1 whitespace-nowrap">{benefit.title}</h3>
      <p className="text-sm text-muted-foreground">{benefit.description}</p>
    </div>
  );
};
